import { useAppStore } from '@/store/appStore';
import { computed } from 'vue';
import { Role } from '@/router/enum';

export default function useAndroidAdmin() {
  const store = useAppStore();

  return computed(
    () => store.isAdmin || store.permission.includes(Role.ANDROID_ADMIN),
  );
}
